// extracted by mini-css-extract-plugin
module.exports = {"locale":"Locale-locale_ff7009a5","icon":"Locale-icon_b7b0f211"};